<style lang="css">
  #table {
    width: 1100px;
    margin: 0 auto;
    overflow: hidden;
  }

  #btn-wrap {
    width: 1100px;
    margin: 0 auto;
    display: flex;
    align-items: right;
  }
</style>

<template>
  <div id="container">
    <div class="main">
      <div id="table">
        <party-temp7 ref="partyTemp"></party-temp7>
      </div>
      <div
          style="width:1100px; margin: 0 auto; text-align:right;padding-right:100px;margin-bottom:50px;"
      >
        <Button type="default" @click="cancel" style="margin-right:50px;width:100px;">取消</Button>
        <Button status="primary" @click="commit" style="width:100px;">提交</Button>
      </div>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import PartyTemp7 from "@/components/party/PartyTemp7.vue";

  const empties = [undefined, "", null, "null", {}, []];
  import {showLoading, hideLoading, isEmpty} from "@/utils/util";
  import {isMoment} from "moment";

  export default {
    name: "VoyageCharterParty",
    components: {
      PartyTemp7,
    },
    props: {},
    data() {
      return {
        cate: "7",
        submitLoading: false,
      };
    },
    mounted() {
      this.submitLoading = false;
    },
    methods: {
      async init(agreementType, formData, goodsData) {
        //船舶信息（导入）：船名，船籍港，船舶种类，载重吨，总吨，净吨，船长/船宽，满载吃水，
        let carShipData = null;
        if (
          !empties.includes(goodsData) &&
          !empties.includes(goodsData.carShipNum)
        ) {
          let res = await $api.carShip.request("queryShipList", {
            shipName: goodsData.carShipNum,
            page: 1,
            rows: 50,
          });
          if (res.status == 1 && res.data.rows.length > 0) {
            res.data.rows.forEach((item) => {
              if (item.shipName == goodsData.carShipNum) {
                for (var i in item) {
                  if (isEmpty(item[i])) {
                    item[i] = "";
                  }
                }
                carShipData = item;
              }
            });
          }
        }

        //航次租船模板数据
        let specificClauseList = [];
        let specificClauseListRes = await $api.other.specificClauseListModel.GET();
        if (specificClauseListRes.status == 1) {
          specificClauseList = specificClauseListRes.data;
        }
        this.$refs.partyTemp.init(
          agreementType,
          formData,
          goodsData,
          carShipData,
          specificClauseList
        );
      },
      async commit() {
        let formData = this.$refs.partyTemp.returnData();

        //日期转时间戳
        if (!empties.includes(formData.laydaysDateStr)) {
          formData.laydaysDate = formData.laydaysDateStr
        }
        if (!empties.includes(formData.palletAddTimeStr)) {
          formData.palletAddTime = this.$utils.timestamp(
            this.$utils.toStringDate(formData.palletAddTimeStr)
          );
        }
        if (!empties.includes(formData.shipperAddTimeStr)) {
          formData.shipperAddTime = this.$utils.timestamp(
            this.$utils.toStringDate(formData.shipperAddTimeStr)
          );
        }

        for (var i in formData) {
          if (null === formData[i]) {
            formData[i] = ''
          }
        }

        showLoading();
        let res = await $api.agreement.request("createVoyageContract", formData);
        hideLoading();
        if (res.status == 1) {
          this.$emit("addFile", res.data);
          this.$emit("close");
        } else {
          if (empties.includes(res.message)) res.message = "接口异常";
          this.$XModal.message(res.message);
        }
      },
      cancel() {
        this.$emit("close");
      },
    },
  };
</script>